/**
 * EmploymentTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const EmploymentTab = ({ ctx }) => {
  const {
    formData,
    handleEmploymentChange,
  } = ctx;

  return (
          <TabsContent value="employment">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Briefcase className="w-5 h-5 text-stone-700" />
                  Employment Information
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <Label>Hire Date *</Label>
                    <Input
                      type="date"
                      value={formData.employment_info.hire_date}
                      onChange={(e) => handleEmploymentChange('hire_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Employment Type</Label>
                    <select
                      value={formData.employment_info.employment_type}
                      onChange={(e) => handleEmploymentChange('employment_type', e.target.value)}
                      className="w-full h-10 px-3 border rounded-md"
                    >
                      <option value="FT">Full Time</option>
                      <option value="PT">Part Time</option>
                      <option value="CT">Contract</option>
                      <option value="IN">Intern</option>
                      <option value="TM">Temporary</option>
                    </select>
                  </div>
                  <div>
                    <Label>Probation End Date</Label>
                    <Input
                      type="date"
                      value={formData.employment_info.probation_end_date}
                      onChange={(e) => handleEmploymentChange('probation_end_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Confirmation Date</Label>
                    <Input
                      type="date"
                      value={formData.employment_info.confirmation_date}
                      onChange={(e) => handleEmploymentChange('confirmation_date', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label>Notice Period (Days)</Label>
                    <Input
                      type="number"
                      value={formData.employment_info.notice_period_days}
                      onChange={(e) => handleEmploymentChange('notice_period_days', parseInt(e.target.value) || 0)}
                      min="0"
                    />
                  </div>
                  <div>
                    <Label>Work Schedule</Label>
                    <Input
                      value={formData.employment_info.work_schedule}
                      onChange={(e) => handleEmploymentChange('work_schedule', e.target.value)}
                      placeholder="9 AM - 6 PM"
                    />
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default EmploymentTab;
